import { v4 as uuidv4 } from "uuid";
import * as yup from "yup";
import { Schema } from "../../schema";
import { SingleValueObject } from "../base-value-object";
export const NUMBER_ID_LENGTH = 16;
export class BaseIdentity extends SingleValueObject {
    v;
    id;
    constructor(v) {
        super({ id: v });
        this.v = v;
        this.id = v;
    }
    equals(t) {
        return this.id === t?.id;
    }
    getValue() {
        return this.id;
    }
    toString() {
        return this.id;
    }
}
export class NumberIdentity extends BaseIdentity {
    static generate() {
        //TODO create more safe generator
        const number = Math.ceil(Math.random() * Number.MAX_SAFE_INTEGER);
        const id = ("0".repeat(NUMBER_ID_LENGTH) + number).slice(-NUMBER_ID_LENGTH);
        return new NumberIdentity(id);
    }
    validator(args) {
        return this.validate(args, NumberIdentity.schema);
    }
    static schema(required = true) {
        return Schema.required({
            id: yup.string().number().length(NUMBER_ID_LENGTH).label("ID"),
        }, required);
    }
}
export class UUIDIdentity extends BaseIdentity {
    static generate() {
        return new UUIDIdentity(uuidv4());
    }
    validator(args) {
        return this.validate(args, UUIDIdentity.schema);
    }
    static schema(required = true) {
        return Schema.required({
            id: yup.string().uuid().label("ID"),
        }, required);
    }
}
//# sourceMappingURL=identity.js.map